module.exports = __webpack_public_path__ + "static/hidromovil1.5b419de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/hidromovil1.jpg
// module id = 1261
// module chunks = 35783957827783